import React, { Component } from "react";
import cookie from "react-cookies";
import BASE_URL from "../Global Variables/GlobalVariables";
import { ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import ApiGateway from "./DataServices";
import GBLVAR from "../Global Variables/GlobalVariables";
import {Countries} from "../Components/Countries";
var moment_timezone = require('moment-timezone');

export default function getAuthToken() {
  var token = cookie.load("AuthAgent", { path: "/" });
  return token;
}

export function handleKeyEvent(e) {
  var theEvent = e || window.event;
  if (theEvent.type === 'paste') {
      key = e.clipboardData.getData('text/plain');
  } else {
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
  }
  var regex = /^[0-9]+$/;
  if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export function setCookie(key, value) {
  cookie.save(key, value, {
    path: "/",
    maxAge: 19900000,
    secure: false
  });
}

export function saveUserShowHome(self, response, from_where) {
  console.log("muthuresponse",response)
  //alert(from_where);
  if (from_where === "from_signin") {
    setCookie("customer_id	", response.customer_id);
    setCookie("auth_token	", response.auth_token);
    setCookie("authentication", response.authentication);
    setCookie("account_type", "logged_user");
  } else if(from_where === 'guest_login'){
    setCookie("auth_token	", response.auth_token);
    setCookie("authentication", response.authentication);
    setCookie("account_type", response.account_type);
  }
}

export function currencyFormatter(amount, code) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: code.code }).format(amount);
}

export function textCapitalize(data) {
  if (data !== undefined && data !== null && data !== "") {
    return data.charAt(0).toUpperCase() + data.slice(1);
  } else {
    return data;
  }
}

export function returnTimeZoneDate(date) {
  if (date === "" || date === undefined || date === null || date === "-") {
    return "";
  }
  console.log("moment().tz('Abu Dhabi').format('MM/DD/YYYY')",
    moment_timezone(date).tz('Abu Dhabi').format("DD-MM-YYYY h:mm a")
  )
  var date = moment(date);
  // return moment
  //   .utc(date)
  //   .local()
  //   .format("DD-MM-YYYY h:mm a");
  return moment_timezone(date).tz('Asia/Dubai').format("DD-MM-YYYY h:mm a")
}

export function calculateTotal(subTotal,vat_tax,shipping_fee,additional_product_fees) {
  var Total = parseFloat(subTotal) + parseFloat(vat_tax) + parseFloat(shipping_fee);
  if(additional_product_fees !== undefined &&   additional_product_fees !== null &&   additional_product_fees.length !== 0 ) {
    additional_product_fees.map((fee,i)=>{
      Total += parseFloat(fee.tax_amount) ;
    })
  }     
  return {
    Total: Total
  };
}

export function calculateAmount(cartItems,vat_tax,additional_product_fees,shipping_fee){
  var subTotal = calculateSubTotalAmount(cartItems);
  var vat_tax = vat_tax;
  var additional_product_fees = additional_product_fees;
  var shipping_fee = shipping_fee;
  vat_tax.total = 0;
  cartItems.map((cart_product)=>{           
    if(cart_product.inclusive_tax === "No"){
      vat_tax.total += (cart_product.total * vat_tax.tax_value) /100;
    }
  })
  additional_product_fees.map((fee)=>{
    if(fee.tax_type === "percentage"){
      fee.tax_amount = (subTotal * fee.tax_value) / 100;
    } 
    else if(fee.tax_type === "price"){
      fee.tax_amount = (fee.tax_value);
    } 
    else{
      fee.tax_amount = (subTotal * fee.tax_value) / 100;
    }                  
  })
  return {
    subTotal : subTotal , vat_tax : vat_tax,additional_product_fees: additional_product_fees
  }
}

export function calculateSubTotalAmount(cart_product) {
  var subTotal = 0;
  cart_product.map((item, i) => {
    subTotal +=
      Math.round(
        parseInt(
          item.order_quantity === "" || item.order_quantity === 0 || isNaN(item.order_quantity)
            ? 1
            : item.order_quantity
        ) *
        item.product_price *
        100
      ) / 100;
  })
  return subTotal;
}

export function calculateSubTotal(cart_product) {
  var subTotal = 0;
  cart_product.map((item, i) => {
    subTotal +=
      Math.round(
        parseInt(
          item.order_quantity === "" || item.order_quantity === 0 || isNaN(item.order_quantity)
            ? 1
            : item.order_quantity
        ) *
        item.product_price *
        100
      ) / 100;
  })
  return {
    subTotal: subTotal
  };
}

export function getCountryList(callback){  
  ApiGateway.get(
  `${GBLVAR.BASE_USER_TEST_API_URL}/country/list`,
  function (response) {
    if(response.data.country_list.length !== 0){ 
      var countryList = []       
      Countries.map((country)=>{
        response.data.country_list.map((elem) => {
          if(elem === country["2digit"]) {
            countryList.push(country);                    
          }
        })          
      })
      callback(countryList);
    } else{
      callback(Countries);
    }
  });
}


